const createPreviewMiddleware = (allowActionTypes = []) => {
  return () => (next) => (action) => {
    // preview mode AND action が function でない AND action が許可されてなければ STOP する
    if (
      window.preview == true &&
      typeof action != "function" &&
      !allowActionTypes.includes(action.type)
    ) {
      return null;
    }
    return next(action);
  };
};

const preview = createPreviewMiddleware();
preview.withAllowActionTypes = createPreviewMiddleware;

export default preview;
